import { useState, useCallback } from 'react';
import type { StateHoverInfo } from 'components/InteractiveMap/BrazilStatesLayer';

interface CursorPos {
  lat: number;
  lng: number;
  x: number;
  y: number;
}

export interface LayerDef {
  key: string;
  label: string;
}

export default function useAgroMapState(layerDefs: LayerDef[]) {
  const [cursorPos, setCursorPos] = useState<CursorPos | null>(null);
  const [hoveredState, setHoveredState] = useState<StateHoverInfo | null>(null);
  const [isOverMarker, setIsOverMarker] = useState(false);
  const [layers, setLayers] = useState<Record<string, boolean>>(
    () => Object.fromEntries(layerDefs.map(({ key }) => [key, true])),
  );

  const handleMove = useCallback((lat: number, lng: number, x: number, y: number) => {
    setCursorPos({
      lat, lng, x, y,
    });
  }, []);

  const handleLeave = useCallback(() => {
    setCursorPos(null);
    setHoveredState(null);
  }, []);

  const handleStateHover = useCallback((info: StateHoverInfo) => {
    setHoveredState(info);
  }, []);

  const handleStateLeave = useCallback(() => setHoveredState(null), []);
  const handleMarkerEnter = useCallback(() => setIsOverMarker(true), []);
  const handleMarkerLeave = useCallback(() => setIsOverMarker(false), []);

  const handleToggle = useCallback((key: string) => () => {
    setLayers((prev) => ({ ...prev, [key]: !prev[key] }));
  }, []);

  return {
    layers,
    handleToggle,
    cursorPos,
    handleMove,
    handleLeave,
    hoveredState,
    handleStateHover,
    handleStateLeave,
    isOverMarker,
    handleMarkerEnter,
    handleMarkerLeave,
  };
}
